// assets
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import ExperimentOutlined from '@ant-design/icons/ExperimentOutlined';
import ReloadOutlined from '@ant-design/icons/ReloadOutlined';
import CommentOutlined from '@ant-design/icons/CommentOutlined';
import WarningOutlined from '@ant-design/icons/WarningOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import FileSearchOutlined from '@ant-design/icons/FileSearchOutlined';
import TrophyOutlined from '@ant-design/icons/TrophyOutlined';
import SyncOutlined from '@ant-design/icons/SyncOutlined';
import EyeOutlined from '@ant-design/icons/EyeOutlined';
import BookOutlined from '@ant-design/icons/BookOutlined';

// icons
const icons = {
  DashboardOutlined,
  UserOutlined,
  CalendarOutlined,
  FileTextOutlined,
  ExperimentOutlined,
  ReloadOutlined,
  CommentOutlined,
  WarningOutlined,
  SettingOutlined,
  FileSearchOutlined,
  TrophyOutlined,
  SyncOutlined,
  EyeOutlined,
  BookOutlined
};

// ==============================|| MENU ITEMS - THERAPIST ||============================== //

// `catalogueCode` ties an item to the specific Features and Pages PAGE it shows
// (rbac_app_page.code), matched by CODE not URL: the therapist reaches the same screen
// at a role-prefixed URL (/therapist/my-calendar) the supervisor-centric catalogue
// route does not cover, so a URL match misses it. The page code — not the feature code
// — is used so switching off a single page hides it; a switched-off FEATURE also
// reports all its pages as disabled, so that case is covered by the same code. Where no
// catalogue page matches (the therapist dashboard), the feature code is the fallback.
// See menu-items/catalogueVisibility.js.
const therapist = {
  id: 'group-therapist',
  title: 'Therapist',
  icon: icons.UserOutlined,
  type: 'group',
  children: [
    {
      id: 'therapist-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/therapist/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
      offlineDisabled: true, // Dashboard not available offline
      catalogueCode: 'dashboard_reports'
    },
    {
      id: 'therapist-my-calendar',
      title: 'My Calendar',
      type: 'item',
      url: '/therapist/my-calendar',
      offlineUrl: '/offline/my-calendar', // Offline version available
      icon: icons.CalendarOutlined,
      breadcrumbs: false,
      catalogueCode: 'my_calendar'
    },
    // Hidden: Session Calendar
    // {
    //   id: 'therapist-calendar',
    //   title: 'Session Calendar',
    //   type: 'item',
    //   url: '/therapist/calendar',
    //   icon: icons.CalendarOutlined,
    //   breadcrumbs: false
    // },
    {
      id: 'therapist-child',
      title: 'Child Profile',
      type: 'item',
      url: '/therapist/child',
      icon: icons.UserOutlined,
      breadcrumbs: false,
      offlineDisabled: true, // Child Profile not available offline
      catalogueCode: 'child_directory'
    },
    {
      id: 'therapist-skills',
      title: 'Skills Repository',
      type: 'item',
      url: '/therapist/skills',
      icon: icons.BookOutlined,
      breadcrumbs: false,
      offlineDisabled: true,
      catalogueCode: 'skill_repository_page'
    },
    {
      // Shown only when the role is granted `clinical_settings` in Role Definitions
      // (filterMenuByGrants gates on catalogueCode). Points at the THERAPIST's own
      // Settings screen — which renders the Mastery Criteria tab when the page grant is
      // present — so the generic grant extra for the same code (which would otherwise
      // land on /supervisor/settings) is deduped away in favour of this persona URL.
      id: 'therapist-settings',
      title: 'Settings',
      type: 'item',
      url: '/therapist/settings',
      icon: icons.SettingOutlined,
      breadcrumbs: false,
      catalogueCode: 'clinical_settings'
    },
    {
      id: 'therapist-sync-status',
      title: 'Sync Status',
      type: 'item',
      url: '/therapist/sync-status',
      icon: icons.SyncOutlined,
      breadcrumbs: false
    }
    // {
    //   id: 'therapist-data-collection',
    //   title: 'Data Collection',
    //   type: 'item',
    //   url: '/therapist/data-collection',
    //   offlineUrl: '/offline/data-entry', // Offline version available
    //   icon: icons.FileTextOutlined,
    //   breadcrumbs: false
    // },
    // Hidden per request — kept commented so they can be re-enabled quickly.
    // ,{
    //   id: 'therapist-daily-mand-v1',
    //   title: 'View 1 (Old Daily Mand)',
    //   type: 'item',
    //   url: '/therapist/daily-mand-v1',
    //   icon: icons.EyeOutlined,
    //   breadcrumbs: false
    // },
    // {
    //   id: 'therapist-daily-mand-v2',
    //   title: 'View 2 (Latest Daily Mand)',
    //   type: 'item',
    //   url: '/therapist/daily-mand-v2',
    //   icon: icons.EyeOutlined,
    //   breadcrumbs: false
    // }
  ]
};

export default therapist;
